module.exports = __webpack_public_path__ + "img/4.17d28c37.jpg";